import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";
import { cn } from "@/lib/utils";
import { Guest, GuestType } from "@classview/shared-types";

function getName(attendee: Guest) {
  return attendee.type === GuestType.User
    ? `${attendee.firstName} ${attendee.lastName}`
    : attendee.email;
}

function getMonogram(attendee: Guest) {
  return attendee.type === GuestType.User
    ? `${attendee.firstName[0]}${attendee.lastName[0]}`
    : attendee.email[0];
}

type AttendeesListProps = {
  attendees: Guest[];
};

/**
 * Displays a list of attendees in the session single view.
 * This is NOT an edit/form component.
 */
export function AttendeesList(props: AttendeesListProps) {
  const { attendees } = props;

  if (attendees.length === 0) {
    return null;
  }

  return (
    <ScrollArea
      type="always"
      className={cn("rounded-md border border-border", {
        "h-[427px]": attendees.length > 7, // 7 items * 61px = 427px
      })}
    >
      <div className="divide-y divide-border">
        {attendees.map((attendee) => (
          <div
            key={attendee.email}
            className="flex items-center justify-between px-4 py-2"
          >
            <div className="flex min-w-0 items-center">
              <Avatar>
                {/* <AvatarImage src="https://github.com/shadcn.png" /> */}
                <AvatarFallback className="bg-border capitalize text-muted">
                  {getMonogram(attendee)}
                </AvatarFallback>
              </Avatar>
              <div className="ml-2 min-w-0">
                {attendee.type === GuestType.Guest ? (
                  <Badge variant="outline">
                    <span className="flex items-center">
                      <span className="mr-2 inline-block size-2 rounded-full bg-warning" />
                      External
                    </span>
                  </Badge>
                ) : (
                  <div className="flex items-center">
                    <p className="truncate text-sm font-medium text-foreground">
                      {getName(attendee)}
                    </p>
                    {attendee.isModerator && (
                      <Badge variant="outline" className="ml-2">
                        <span className="flex items-center">Moderator</span>
                      </Badge>
                    )}
                    {attendee.isHost && (
                      <Badge variant="outline" className="ml-2">
                        <span className="flex items-center">Host</span>
                      </Badge>
                    )}
                  </div>
                )}

                <p className="truncate text-sm text-muted-foreground">
                  {attendee.email}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </ScrollArea>
  );
}
